// @ts-nocheck
import React, { useState } from "react";
import {
  URL_API_SIA,
  HP_medrano,
  HP_campus,
  HP_APP,
  HP_sysgestion,
  HP_sysadmin,
  HP_SCI,
  OPCION_sysgestion,
  OPCION_sysadmin,
  OPCION_SCI,
} from "../Contantes/Constantes";
import makeStyles from "@mui/styles/makeStyles";
import { Form } from "../Componentes/useForm";
import { FormSelect } from "../Componentes/FormSelect";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import STU from "./STU";
import SoporteApps from "./SoporteApps";
import Joi from "joi";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import axios from "axios";
import { useBody } from "../Body/state/BodyContext";
import SinapTheme from "../styles/SinapTheme";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { BotonVerde } from "../Difusiones/Componentes/BotonVerde";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useAuth } from "../Auth/State/AuthContext";

const Root = styled("div")({
  position: "relative",
  top: "35%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  textAlign: "left",
  backgroundColor: "background.paper",
  boxShadow: 24,
  padding: "3%",
  padding: "32px",
  "@media (max-width: 1280px)": {
    width: "100%",
    height: "100%",
    left: "40%",
    padding: "1%",
    top: "30%",
    textAlign: "center",
  },
  "@media (min-width: 960px)": {
    width: "80%",
    height: "80%",
  },
  "@media (min-width: 1280px)": {
    width: "960px",
    height: "80%",
  },
});

const useStyles = makeStyles(() => ({
  select: {
    margin: "8px",
    width: "100%",
  },
  paperContent: {
    margin: "40px",
    padding: "24px",
  },
  padding: {
    padding: "10px 10px 10px 0px",
  },
  grid: {
    "@media (max-width: 1280px)": {
      width: "120%",
      height: "100%",
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    "& > *": {
      margin: "8px",
    },
    flexGrow: 1,
    maxWidth: "752px",
  },
}));

export const Ticketera = () => {
  const classes = useStyles();
  const [sede, setSede] = useState(false); // es para que se habilite el campo de area
  const estadoInicial = {
    APP: false,
    STU: false,
    otro: false,
  };
  const [estados, setEstados] = useState(estadoInicial);
  const [loading, setLoading] = useState(false);
  const { setMesssage, setSuccess } = useBody();
  const [problemas, setProblemas] = useState([])
  const [servcios, setServicios] = useState([]);
  const { setMessage } = useBody();
  const { user, isLogedIn } = useAuth();
  const axiosInstance = setupInterceptorsTo(axios.create());
  const sedes = [
    {
      nombre: "Medrano",
      id: 1,
    },
    {
      nombre: "Campus",
      id: 2,
    },
  ];
  const areas = [
    {
      nombre: "TIC - Soporte Tecnico Usuarios",
      id: 1,
    },
    {
      nombre: "TIC - Soporte Aplicaciones",
      id: 2,
    },
  ];

  const valueGIncicial = {
    // G de gernal
    sede: null,
    area: "",
  };
  const valueSTUInicial = {
    problema: "",
    asunto: "",
    nroInterno: "",
    oficina: "",
    inventario: "",
    descripcion: "",
    adjuntos: [],
  };
  const valueSAPPInicial = {
    servicio: "",
    asunto: "",
    descripcion: "",
    adjuntos: [],
  };

  const [valuesG, setValuesG] = useState(valueGIncicial);
  const [valuesSTU, setValuesSTU] = useState(valueSTUInicial, []);
  const [valuesSoporteApps, setvaluesSoporteApps] = useState(
    valueSAPPInicial,
    []
  );

  let formulario;
  if (estados.STU)
    formulario = (
      <STU value={valuesSTU} setValue={setValuesSTU} problemas={problemas} />
    );
  if (estados.APP)
    formulario = (
      <SoporteApps
        value={valuesSoporteApps}
        setValue={setvaluesSoporteApps}
        servicios={servcios}
      />
    ); // cambiar
  if (estados.otro) formulario = ""; // todo poner el formualrio comun de asunto y descripcion

  const mapProbYSer = (data, tipo) => {
    return {
      id: data.id,
      nombre: data[tipo],
    };
  };

  const traerProblemaYServicio = async (tipo) => {
    axiosInstance({
      method: "GET",
      url: URL_API_SIA + "/" + tipo,
    })
      .then((response) => {
        let array = [];
        if (tipo === "problemas") {
          array = response.data.data.map((data) =>
            mapProbYSer(data, "problema")
          );
          setProblemas(array);
        } else if (tipo === "servicios") {
          array = response.data.data.map((data) =>
            mapProbYSer(data, "servicio")
          );
          setServicios(array);
        }
      })
      .catch((e) => {
        setMessage(
          "Hubo un error al traer los problemas/servicios (Código de error : 00022)"
        );
      });
  };

  const traerNombreProblemaYservicio = async (tipo, id) => {
    let titulo = null;
    await axiosInstance({
      method: "GET",
      url: URL_API_SIA + "/" + tipo + "/" + id,
    })
      .then((response) => {
        if (tipo === "problemas") {
          titulo = response.data.problema;
        } else if (tipo === "servicios") {
          titulo = response.data.servicio;
        }
      })
      .catch((e) => {
        console.error(
          "Hubo un error al traer el problema/servicio (Código de error : 00023)"
        );
      });
    return titulo;
  };

  const todosFalse = () => {
    setEstados(estadoInicial);
  };

  const resetearForm = () => {
    setSede(false);
    todosFalse();
    setLoading(false);
    setProblemas(false);
    setServicios(false);
    setValuesG(valueGIncicial);
    setValuesSTU(valueSTUInicial);
    setvaluesSoporteApps(valueSAPPInicial);
  };

  const topicAPP = () => {
    let topic;
    if (valuesSoporteApps.servicio === OPCION_sysgestion) {
      topic = HP_sysgestion;
    } else if (valuesSoporteApps.servicio === OPCION_sysadmin) {
      topic = HP_sysadmin;
    } else if (valuesSoporteApps.servicio === OPCION_SCI) {
      topic = HP_SCI;
    } else {
      topic = HP_APP;
    }

    return topic;
  };

  const handleSelectChange = async (e) => {
    setValuesG({
      ...valuesG,
      [e.target.name]: e.target.value,
    });

    if (e.target.value === 1 && e.target.name === "area") {
      //1= id de STU
      todosFalse();
      setEstados((prevProfile) => ({
        ...prevProfile,
        ["STU"]: true,
      }));

      traerProblemaYServicio("problemas");
    }
    if (e.target.value === 2 && e.target.name === "area") {
      //2= id de soporte apps
      todosFalse();
      setEstados((prevProfile) => ({
        ...prevProfile,
        ["APP"]: true,
      }));
      traerProblemaYServicio("servicios");
    }
    if (e.target.name === "sede" && !sede) {
      setSede(true);
    }
  };

  const convertirBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let render = new FileReader();
      render.readAsDataURL(file);
      render.onload = () => resolve(render.result);
    });
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    e.preventDefault();
    let body;
    body = {
      alert: true,
      autorespond: true,
      source: "API",
      name: user.uid,
      topicId: "",
      email: user.email,
      phone: null,
      subject: "",
      // ip: "123.211.233.122", //todo cambiar cuando facu me diga
      message: "",
      attachments: [],
    };
    let error;
    error = validateForm("sede-area");
    if (estados.STU) {
      const topicId = valuesG.sede === 1 ? HP_medrano : HP_campus;
      const titulo = await traerNombreProblemaYservicio(
        "problemas",
        valuesSTU.problema
      );
      body["topicId"] = topicId;
      body["subject"] = titulo + " - " + valuesSTU.asunto;
      body["message"] =
        "Motivo: " +
        valuesSTU.asunto +
        "<br><br>Numero de interno: " +
        valuesSTU.nroInterno +
        "<br><br> Oficina: " +
        valuesSTU.oficina +
        "<br><br> Inventario: " +
        valuesSTU.inventario +
        "<br><br> Descripcion: " +
        valuesSTU.descripcion;
      body["attachments"] = await Promise.all(
        valuesSTU.adjuntos.map(async (f) => {
          const base64 = await convertirBase64(f);
          return {
            [f.name]: base64,
          };
        })
      );
      error = validateForm("STU");
    } else if (estados.APP) {
      const topicId = topicAPP(); //cambiar por la de soporte apps
      const titulo = await traerNombreProblemaYservicio(
        "servicios",
        valuesSoporteApps.servicio
      );
      body["topicId"] = topicId;
      body["subject"] = titulo + " - " + valuesSoporteApps.asunto;
      body["message"] =
        "Motivo: " +
        valuesSoporteApps.asunto +
        "<br><br> Descripcion: " +
        valuesSoporteApps.descripcion;
      body["attachments"] = await Promise.all(
        valuesSoporteApps.adjuntos.map(async (f) => {
          const base64 = await convertirBase64(f);
          return {
            [f.name]: base64,
          };
        })
      );
      error = validateForm("SoporteApps");
    } else if (estados.otro) {
      body = valuesG; // todo poner el formualrio comun de asunto y descripcion
      error = validateForm("otro");
    }
    if (error) {
      mensajeAlertaFalloFormulario(error);
      setLoading(false);
      return;
    }

    axiosInstance({
      method: "POST",
      url: URL_API_SIA + "/os/crear/ticket",
      data: body,
    })
      .then(() => {
        setSuccess("El ticket fue creado.");
        resetearForm();
      })
      .catch((err) => {
        setMessage("No se pudo crear el ticket.");
      })
      .then(() => {
        setLoading(false);
      });
  };

  function validateForm(tipo) {
    let validation;
    switch (tipo) {
      case "sede-area":
        const area_sede = valuesG;
        validation = validationSchemaAS.validate(area_sede);
        break;
      case "STU":
        validation = validationSchemaSTU.validate(valuesSTU);
        break;

      case "SoporteApps":
        validation = validationSchemaAPP.validate(valuesSoporteApps);
        break;

      case "otro":
        validation = validationSchemaOtro.validate();
        break;
    }

    if (validation.error) return validation.error.details[0].path[0];
  }

  const validationSchemaAS = Joi.object({
    sede: Joi.number().required(),
    area: Joi.number().required(),
  });

  const validationSchemaSTU = Joi.object({
    problema: Joi.number().required(),
    asunto: Joi.string().min(10).max(100).required(),
    nroInterno: Joi.number().required(),
    oficina: Joi.string().required(),
    inventario: Joi.string()
      .min(6)
      .max(8)
      .regex(/N[a-z|A-Z|0-9]-?[a-z|A-Z|0-9]{4,6}/)
      .allow(""),
    descripcion: Joi.string().min(3).max(1000).required(),
    adjuntos: Joi.array(),
  });

  const validationSchemaAPP = Joi.object({
    servicio: Joi.number().required(),
    asunto: Joi.string().min(10).max(100).required(),
    descripcion: Joi.string().min(3).max(1000).required(),
    adjuntos: Joi.array(),
  });

  const validationSchemaOtro = Joi.object({});

  const mensajeAlertaFalloFormulario = (fallo) => {
    //todo agregar los fallos del otro formulario
    if (fallo === "sede") setMessage("Es obligatorio seterar la sede");
    if (fallo === "area") setMessage("Es obligatorio seterar el area");
    if (fallo === "problema") setMessage("Es obligatorio seterar el problema");
    if (fallo === "servicio") setMessage("Es obligatorio seterar el servicio");
    if (fallo === "asunto")
      setMessage("El asunto debe tener entre 10 y  100 caracteres");
    if (fallo === "nroInterno")
      setMessage("El numero de interno debe ser un numero");
    if (fallo === "oficina")
      setMessage("La oficina que esta pasando no existe"); // Me pasaron que hay oficinas que no tienen numero, por lo que lo puse como string y esto es para zafar hasta que este el modulo áreas
    if (fallo === "inventario")
      setMessage("El inventario debe cumplir el siguiente formato: XX-XXXX");
    if (fallo === "descripcion")
      setMessage("La descripcion debe tener entre 3 y 1000 caracteres");
    if (fallo === "archivos")
      setMessage("Hubo un error en la carga de archivos");
  };

  return (
    <Box
      sx={{
        minHeight: "70vh",
        py: 4,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md">
        <StyledEngineProvider injectFirst>
          <Box
            component={Paper}
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 2,
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{ mb: 4, color: "#333" }}
            >
              Reporte de incidentes
            </Typography>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <FormSelect
                  name="sede"
                  label="Sede"
                  selectedValue={valuesG.sede}
                  onChange={handleSelectChange}
                  items={sedes}
                />
                <FormSelect
                  name="area"
                  label="Área"
                  selectedValue={valuesG.area}
                  onChange={handleSelectChange}
                  items={areas}
                  disabled={!sede}
                />
                {formulario}
              </Box>
              <Box sx={{ mt: 3 }}>
                {loading ? (
                    <CircularProgress color="secondary" sx={{ mt: 4 }} />
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                        sx={{
                          py: 1.5,
                          borderRadius: 2,
                          fontWeight: "bold",
                          textTransform: "none",
                          fontSize: "1rem",
                        }}
                    >
                      Crear Ticket
                    </Button>
                )}

              </Box>
            </form>
          </Box>
        </StyledEngineProvider>
      </Container>
    </Box>
  );
};
